import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  ariaLabel?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  ariaLabel
}: CTAButtonProps) {
  return <motion.button onClick={onClick} className={`bg-gold hover:bg-gold-light text-navy-dark font-heading font-bold text-lg px-8 py-4 rounded-lg transition-colors duration-200 ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} aria-label={ariaLabel} data-id="element-6">
      {children}
    </motion.button>;
}